import Geocode from "react-geocode"

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
export const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

// Opciones compartidas de useJsApiLoader: el loader falla si se llama con opciones
// distintas, y `libraries` debe ser la misma referencia para no recargar el script.
export const MAPS_LOADER_OPTIONS = {
  googleMapsApiKey: MAPS_API_KEY,
  libraries: ["geometry", "drawing", "places"]
}

Geocode.setApiKey(MAPS_API_KEY)

// set response language. Defaults to english.
Geocode.setLanguage("es")

export {Geocode}